(() => {
  'use strict';
  if (!location.pathname.startsWith('/products/')) return;

  const replacements = new Map([
    ['Customer reviews', 'Müşteri yorumları'],
    ['Write a review', 'Yorum yaz'],
    ['Reviews', 'Yorumlar'],
    ['No reviews yet', 'Henüz yorum yok'],
    ['Search reviews', 'Yorumlarda ara'],
    ['Most relevant', 'En ilgili'],
    ['Most recent', 'En yeni'],
    ['Highest rating', 'En yüksek puan'],
    ['Lowest rating', 'En düşük puan'],
    ['All variants', 'Tüm varyantlar'],
    ['Verified buyer', 'Doğrulanmış alıcı'],
    ['All ratings', 'Tüm puanlar'],
    ['With media', 'Fotoğraflı'],
    ['Clear all filters', 'Tüm filtreleri temizle'],
    ['No matching reviews', 'Eşleşen yorum yok'],
    ['Try another search, or clear some filters', 'Başka bir arama deneyin veya filtreleri temizleyin'],
    ['TRY ANOTHER SEARCH, OR CLEAR SOME FILTERS', 'BAŞKA BİR ARAMA DENEYİN VEYA FİLTRELERİ TEMİZLEYİN'],
    ['Clear all', 'Temizle'],
    ['CLEAR ALL', 'TEMİZLE'],
    ['Submit', 'Gönder'],
    ['Cancel', 'Vazgeç'],
    ['review', 'yorum'],
    ['reviews', 'yorum']
  ]);

  const ROOT_SELECTORS = [
    '#klaviyo-product-reviews-wrapper',
    '#klaviyo-reviews-all',
    '.klaviyo-reviews-widget',
    '[class*="klaviyo-reviews"]',
    '[class*="kl_reviews"]'
  ];
  const observed = new WeakSet();
  let discoveryObserver = null;

  const displayLabels = new Set(['müşteri yorumları', 'yorumlar', 'henüz yorum yok', 'eşleşen yorum yok']);
  const filterLabels = new Set(['fotoğraflı', 'tüm puanlar', 'en ilgili', 'tüm filtreleri temizle']);
  const normalize = (v) => String(v || '').trim().toLocaleLowerCase('tr-TR');

  const styleText = (element, kind) => {
    if (!element) return;
    element.style.setProperty('font-family', 'var(--main-font-stack, Arial, Helvetica, sans-serif)', 'important');
    if (kind === 'display') {
      element.style.setProperty('color', '#9d2d00', 'important');
      element.style.setProperty('font-weight', '800', 'important');
      element.style.setProperty('text-transform', 'uppercase', 'important');
    } else if (kind === 'filter') {
      element.style.setProperty('color', '#9d2d00', 'important');
      element.style.setProperty('font-size', '14px', 'important');
      element.style.setProperty('font-weight', '600', 'important');
      element.style.setProperty('text-transform', 'none', 'important');
    }
  };

  const styleReviewButton = (button) => {
    if (!button) return;
    button.style.setProperty('min-width', '140px', 'important');
    button.style.setProperty('min-height', '50px', 'important');
    button.style.setProperty('padding', '0 18px', 'important');
    button.style.setProperty('border', '2px solid #9d2d00', 'important');
    button.style.setProperty('border-radius', '9px', 'important');
    button.style.setProperty('background', '#fff', 'important');
    button.style.setProperty('color', '#9d2d00', 'important');
    button.style.setProperty('font-family', 'var(--main-font-stack, Arial, Helvetica, sans-serif)', 'important');
    button.style.setProperty('font-size', '14px', 'important');
    button.style.setProperty('font-weight', '800', 'important');
    button.style.setProperty('text-transform', 'uppercase', 'important');
  };

  const translateText = (node) => {
    const value = node.nodeValue?.trim();
    if (!value) return;
    if (replacements.has(value)) {
      node.nodeValue = node.nodeValue.replace(value, replacements.get(value));
      return;
    }
    const review = value.match(/^([0-9]+) reviews?$/i);
    if (review) node.nodeValue = node.nodeValue.replace(value, `${review[1]} yorum`);
    const star = value.match(/^([1-5]) stars?$/i);
    if (star) node.nodeValue = node.nodeValue.replace(value, `${star[1]} yıldız`);
    const rel = value.match(/^(?:a|an|([0-9]+)) (minute|hour|day|week|month|year)s? ago$/i);
    if (rel) {
      const units = {minute:'dakika',hour:'saat',day:'gün',week:'hafta',month:'ay',year:'yıl'};
      node.nodeValue = node.nodeValue.replace(value, `${rel[1] || '1'} ${units[rel[2].toLowerCase()]} önce`);
    }
  };

  const apply = (root) => {
    if (!root?.querySelectorAll) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(translateText);

    root.querySelectorAll('[placeholder],[aria-label],[title]').forEach((element) => {
      ['placeholder','aria-label','title'].forEach((attribute) => {
        const value = element.getAttribute(attribute);
        if (value && replacements.has(value)) element.setAttribute(attribute, replacements.get(value));
      });
    });

    root.querySelectorAll('h1,h2,h3,h4,p,span,strong,button,a,[role="button"]').forEach((element) => {
      const label = normalize(element.textContent);
      if (displayLabels.has(label)) styleText(element, 'display');
      if (filterLabels.has(label)) styleText(element, 'filter');
      if (label === 'yorum yaz' || label === 'write a review') styleReviewButton(element.closest('button,a,[role="button"]') || element);
    });
    root.querySelectorAll('.kl_reviews__button').forEach(styleReviewButton);
  };

  const connect = (root) => {
    if (!root || observed.has(root)) return;
    observed.add(root);
    apply(root);
    const observer = new MutationObserver(() => requestAnimationFrame(() => apply(root)));
    observer.observe(root, { childList: true, subtree: true });
  };

  const discover = (root = document) => {
    ROOT_SELECTORS.forEach((selector) => root.querySelectorAll?.(selector).forEach(connect));
    if ([...document.querySelectorAll(ROOT_SELECTORS.join(','))].length && discoveryObserver) {
      discoveryObserver.disconnect();
      discoveryObserver = null;
    }
  };

  const init = () => {
    discover(document);
    if (!document.querySelector(ROOT_SELECTORS.join(','))) {
      const main = document.getElementById('MainContent') || document.body;
      discoveryObserver = new MutationObserver(() => discover(main));
      discoveryObserver.observe(main, { childList: true, subtree: true });
      window.setTimeout(() => {
        discoveryObserver?.disconnect();
        discoveryObserver = null;
      }, 10000);
    }
    document.addEventListener('shopify:section:load', (event) => discover(event.target));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
